import Highcharts from 'highcharts';

export interface DataStatistics {
  general_stats: GeneralStats;
  partner_stats: GeneralStats;
  my_widgets_title: string;
  my_usage_widget: UsageWidget;
  my_percentage_widget: UsageWidget;
  royalty_widget: RoyaltyWidget;
}

export interface GeneralStats {
  barChart: { values: BarChartPoint[] }[];
  pieChart: { label: string; value: number }[];
  title: string;
  barChartOptions: Highcharts.Options;
  pieChartOptions: Highcharts.Options;
}

export interface UsageWidget {
  data: { title: string; label: string; count: number };
}

export interface RoyaltyWidget {
  data: { title: string; label: string; inputs: RoyaltyInput[] };
  royaltyFormSchema: { header: string; lines: any[]; formSchema: any[] };
}

export interface PartnerProcesses {
  name: string;
  rid: string;
  value?: string;
}

export interface PartnerProcessUsage {
  box_title: string;
  rid_usage: { data: { label: string; count: number } };
  rid_usage_percentage: { data: { label: string; count: number } };
}

export const PIE_CHART_COLORS = [
  '#003c4f',
  '#00747a',
  '#dcf600',
  '#01c9b3',
  '#b0d4d6',
  '#001921',
  '#b0eee7',
  '#5c6700',
  '#003133',
  '#b0c3c8',
  '#00544b',
  '#f4fcb0'
];

export interface PieSeriesData {
  name: string;
  y: number;
  legendValue: number;
}

export interface PieChartPoint {
  label: string;
  value: number;
}

export interface BarChartPoint {
  x: string;
  y: number;
}

export interface RoyaltyWidgetData {
  dataApi: string;
  inputs: RoyaltyInput[];
  key: string;
  label: string;
  title: string;
}

export interface RoyaltyInput {
  label: string;
  help: string;
  name: string;
  type: string;
}
